import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as landingblockActions from '../actions/landing-pages.action';
import { switchMap, map, catchError } from 'rxjs/operators';
import { LandingPagesService } from '../../services';
import { Go } from 'src/app/store';

@Injectable()
export class LandingPagesEffects {
  constructor(private actions$: Actions, private PageService: LandingPagesService) {}

  LoadBugs$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(landingblockActions.LoadLandingPages),
      switchMap(() =>
        this.PageService.getPages().pipe(
          map(landingPages => {
            if (!landingPages) {
              return landingblockActions.LoadLandingPagesFail({ error: { status: 404 } });
            }
            return landingblockActions.LoadLandingPagesSuccess({ landingPages });
          }),
          catchError(error => of(landingblockActions.LoadLandingPagesFail({ error })))
        )
      )
    );
  });

  LoadBySlug$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(landingblockActions.LoadLandingPageBySlug),
      switchMap(({ slug }) =>
        this.PageService.getPageBySlug(slug).pipe(
          map(page => {
            if (!page) {
              return landingblockActions.LoadLandingPageBySlugFail({ error: { status: 404 }, slug });
            }
            return landingblockActions.LoadLandingPageBySlugSuccess({ page, slug });
          }),
          catchError(error => {
            return of(landingblockActions.LoadLandingPageBySlugFail({ error, slug }));
          })
        )
      )
    );
  });

  LoadById$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(landingblockActions.LoadLandingPageById),
      switchMap(({ id }) =>
        this.PageService.getPageById(id).pipe(
          map(page => {
            if (!page) {
              return landingblockActions.LoadLandingPageByIdFail({ error: { status: 404 } });
            }

            return landingblockActions.LoadLandingPageByIdSuccess({ page });
          }),
          catchError(error => of(landingblockActions.LoadLandingPageByIdFail({ error })))
        )
      )
    );
  });

  LoadBySlugFail$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(landingblockActions.LoadLandingPageBySlugFail),
      map(({ error }) => {
        return Go({ path: ['/' + error?.status ? error.status.toString() : '404'], extras: { skipLocationChange: true } });
      })
    );
  });
  LoadByIdFail$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(landingblockActions.LoadLandingPageByIdFail),
      map(({ error }) => {
        return Go({ path: ['/' + error?.status ? error.status.toString() : '404'], extras: { skipLocationChange: true } });
      })
    );
  });
}
